import { FC } from "react"

interface SimpleMatchSetComponentProps {
  children: JSX.Element[]
}

export const SimpleMatchSetComponent: FC<SimpleMatchSetComponentProps> = ({
  children,
  ...props
}) => {
  return <>{children}</>
}
